import styled from 'styled-components';

export const BonusWithdrawPanelStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px;
    border-radius: 4px;
    background-color: var(--color-main);
    color: var(--text-color-secondary);
`;

export const BonusWithdrawDividerStyled = styled.hr`
    background: var(--color-surface);
    opacity: 1;
    margin: 16px -16px;
`;